import * as React from "react";
import { forwardRef, memo } from "react";
const SvgVc = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 192 128", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0 0h192v128H0z", fill: "#fcd022" }), /* @__PURE__ */ React.createElement("path", { d: "M144 0h48v128h-48z", fill: "#007c2e" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h48v128H0z", fill: "#002674" }), /* @__PURE__ */ React.createElement("path", { d: "M83.911 92.44L96 115.196l12.089-22.756L96 69.685zM68.267 64l12.089 22.755L92.444 64 80.356 41.244zm31.289 0l12.088 22.756L123.734 64l-12.09-22.756z", fill: "#007c2e" }));
const ForwardRef = forwardRef(SvgVc);
const Memo = memo(ForwardRef);
export default Memo;
